const safeData = [
    {},
    {
        name: "safeOne",
        position: 0
    },
    {
        name: "safeTwo",
        position: 45
    },
    {
        name: "safeThree",
        position: 90
    },
    {
        name: "safeFour",
        position: 135
    },
    {
        name: "safeFive",
        position: 180
    },
    {
        name: "safeSix",
        position: 225
    },
    {
        name: "safeSeven",
        position: 270
    },
    {
        name: "safeEight",
        position: 315
    }
]
    
export default safeData